import { render, staticRenderFns } from "./HeaderCom.vue?vue&type=template&id=08970009&scoped=true"
import script from "./HeaderCom.vue?vue&type=script&lang=js"
export * from "./HeaderCom.vue?vue&type=script&lang=js"
import style0 from "./HeaderCom.vue?vue&type=style&index=0&id=08970009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08970009",
  null
  
)

export default component.exports